import { render, staticRenderFns } from "./GeneralInformationTable.vue?vue&type=template&id=4ec279e3&"
import script from "./GeneralInformationTable.vue?vue&type=script&lang=ts&"
export * from "./GeneralInformationTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports